import { SectionsInterface } from '../../field.interface';

export enum ROOM_POSITION {
	INTERIOR = 'Interior',
	EXTERIOR = 'Exterior'
}

export class Room33Layout {
	sections: SectionsInterface[] = [
		{
			title: 'Room',
			items: [
				[
					{
						cssClass: 'col-md-6',
						options: {
							path: 'InspectionReport.property.structures[0].units[0].levels[{index}].rooms[{index}].roomName',
							label: 'Room Name'
						}
					},
				],
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.structures[0].units[0].levels[{index}].rooms[{index}].description',
							label: 'Describe the room'
						}
					}
				]
			]
		}
	];
}
